export const NO_SEND_MSG_PATHS = [
  '/invited-complete-profile',
  '/my-profile',
];
